import { RegistroDatosPersonalesMercader } from "@pages/producto/mercader/RegistroDatosPersonalesMercader";

/**
 * Pantallas de "datos personales" del wizard v2 propias de una empresa, por tenant. Igual que
 * `cotizadoresV2PorTipo`: si el tenant no está aquí se usa `RegistroDatosPersonales`.
 */
export const registroDatosPersonalesPorEmpresa: Record<string, React.FC> = {
  mercader: RegistroDatosPersonalesMercader,
};
